import React from "react";
import { AlertCircle } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const DeleteSupplierDialog = ({ deleteFor, onClose, onConfirm }) => (
  <AlertDialog open={!!deleteFor} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle className="flex items-center gap-2"><AlertCircle className="h-4 w-4 text-destructive" /> Delete supplier — {deleteFor?.name}?</AlertDialogTitle>
        <AlertDialogDescription>This permanently removes the supplier. Suppliers with existing purchase history cannot be deleted — Deactivate instead to keep the ledger intact.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Keep Supplier</AlertDialogCancel>
        <AlertDialogAction data-testid="supplier-delete-confirm" className="bg-destructive text-destructive-foreground hover:bg-destructive/90" onClick={onConfirm}>Delete Supplier</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
